function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: -192,
  width: 185,
  height: 99
}), /*#__PURE__*/React.createElement("rect", {
  y: -36,
  width: 100,
  height: 30
}), /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 66 -19.5)",
  fill: "#000000",
  fontFamily: "'Helvetica'",
  fontSize: 2.4
}, "http://thenounproject.com"), /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 7.166 -24.5)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0,
  fill: "#000000",
  fontFamily: "'Helvetica-Bold'",
  fontSize: 6.1578
}, "The Noun Project"), /*#__PURE__*/React.createElement("tspan", {
  x: 1.12,
  y: 4.8,
  fill: "#000000",
  fontFamily: "'Helvetica-Bold'",
  fontSize: 4
}, "Icon Template")), /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 -178.5 10.5)",
  fill: "#000000",
  fontFamily: "'Helvetica-Bold'",
  fontSize: 6.1578
}, "Reminders"), /*#__PURE__*/React.createElement("line", {
  fill: "#000000",
  stroke: "#FFFFFF",
  strokeMiterlimit: 10,
  x1: 8,
  y1: -14.5,
  x2: 18,
  y2: -14.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "#000000",
  stroke: "#FFFFFF",
  strokeMiterlimit: 10,
  x1: -179,
  y1: 16.5,
  x2: -162,
  y2: 16.5
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: -170.802,
  y: 31.318,
  fill: "#000000",
  width: 8.721,
  height: 8.642
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000000",
  d: "M-164.455,42.312h4.747v-4.703h-4.747V42.312z M-159.266,42.749h-5.63V37.17h5.63V42.749      L-159.266,42.749z M-166.221,44.062h8.279v-8.203h-8.279V44.062L-166.221,44.062z M-157.5,44.5h-9.163v-9.079h9.163V44.5      L-157.5,44.5z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#000000",
  points: "-166.149,44.133 -166.292,43.991 -158.013,35.787 -157.871,35.929     "
})))), /*#__PURE__*/React.createElement("rect", {
  x: -179,
  y: 58,
  fill: "none",
  width: 35,
  height: 32.5
}), /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 -179 60.1572)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0,
  fill: "#000000",
  fontFamily: "'Helvetica-Bold'",
  fontSize: 3
}, "Strokes"), /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 5,
  fill: "#000000",
  fontFamily: "'Helvetica'",
  fontSize: 2.4
}, "Try to keep strokes at 4px"), /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 10,
  fill: "#000000",
  fontFamily: "'Helvetica'",
  fontSize: 2.4
}, "Minimum stroke weight is 2px"), /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 14.5,
  fill: "#000000",
  fontFamily: "'Helvetica'",
  fontSize: 2.4
}, "For thicker strokes use even "), /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 17.5,
  fill: "#000000",
  fontFamily: "'Helvetica'",
  fontSize: 2.4
}, "numbers: 6px, 8px etc."), /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 22,
  fill: "#000000",
  fontFamily: "'Helvetica-Bold'",
  fontSize: 2.4
}, "Remember to expand strokes "), /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 25,
  fill: "#000000",
  fontFamily: "'Helvetica-Bold'",
  fontSize: 2.4
}, "before saving as an SVG ")), /*#__PURE__*/React.createElement("rect", {
  x: -136.5,
  y: 58,
  fill: "none",
  width: 35,
  height: 32.5
}), /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 -136.5 60.1572)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0,
  fill: "#000000",
  fontFamily: "'Helvetica-Bold'",
  fontSize: 3
}, "Size"), /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 5,
  fill: "#000000",
  fontFamily: "'Helvetica'",
  fontSize: 2.4
}, "Cannot be wider or taller than "), /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 8.5,
  fill: "#000000",
  fontFamily: "'Helvetica'",
  fontSize: 2.4
}, "100px (artboard size)"), /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 13.5,
  fill: "#000000",
  fontFamily: "'Helvetica'",
  fontSize: 2.4
}, "Scale your icon to fill as much of "), /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 16.5,
  fill: "#000000",
  fontFamily: "'Helvetica'",
  fontSize: 2.4
}, "the artboard as possible")), /*#__PURE__*/React.createElement("rect", {
  x: -94,
  y: 58,
  fill: "none",
  width: 35,
  height: 32.5
}), /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 -94 60.1572)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0,
  fill: "#000000",
  fontFamily: "'Helvetica-Bold'",
  fontSize: 3
}, "Ungroup"), /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 5,
  fill: "#000000",
  fontFamily: "'Helvetica'",
  fontSize: 2.4
}, "If your design has more than one "), /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 8,
  fill: "#000000",
  fontFamily: "'Helvetica'",
  fontSize: 2.4
}, "shape, make sure to ungroup")), /*#__PURE__*/React.createElement("rect", {
  x: -50,
  y: 58,
  fill: "none",
  width: 35,
  height: 32.5
}), /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 -50 60.1572)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0,
  fill: "#000000",
  fontFamily: "'Helvetica-Bold'",
  fontSize: 3
}, "Save as"), /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 5,
  fill: "#000000",
  fontFamily: "'Helvetica'",
  fontSize: 2.4
}, "Save as .SVG and make sure "), /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 8,
  fill: "#000000",
  fontFamily: "'Helvetica'",
  fontSize: 2.4
}, "\u201CUse Artboards\u201D is checked")), /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1.0074 0 0 1 -125.542 30.5933)",
  fill: "#000000",
  fontFamily: "'Helvetica'",
  fontSize: 2.5731
}, "100px"), /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1.0074 0 0 1 -41 39)",
  fill: "#000000",
  fontFamily: "'Helvetica-Bold'",
  fontSize: 5.1462
}, ".SVG"), /*#__PURE__*/React.createElement("rect", {
  x: -126.514,
  y: 34.815,
  fill: "#000000",
  width: 10.261,
  height: 10.185
}), /*#__PURE__*/React.createElement("rect", {
  x: -126.477,
  y: 31.766,
  fill: "#000000",
  width: 0.522,
  height: 2.337
}), /*#__PURE__*/React.createElement("rect", {
  x: -116.812,
  y: 31.766,
  fill: "#000000",
  width: 0.523,
  height: 2.337
}), /*#__PURE__*/React.createElement("rect", {
  x: -127,
  y: 32.337,
  fill: "#000000",
  width: 11.233,
  height: 0.572
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: -83.805,
  y: 33.844,
  fill: "#000000",
  width: 10.305,
  height: 10.156
}), /*#__PURE__*/React.createElement("rect", {
  x: -76.809,
  y: 28.707,
  fill: "#000000",
  width: 3.308,
  height: 3.261
})), /*#__PURE__*/React.createElement("rect", {
  x: -178.5,
  y: 22.5,
  fill: "#000000",
  stroke: "#FFFFFF",
  strokeMiterlimit: 10,
  width: 30,
  height: 30
}), /*#__PURE__*/React.createElement("rect", {
  x: -136.5,
  y: 22.5,
  fill: "#000000",
  stroke: "#FFFFFF",
  strokeMiterlimit: 10,
  width: 30,
  height: 30
}), /*#__PURE__*/React.createElement("rect", {
  x: -93.5,
  y: 22.5,
  fill: "#000000",
  stroke: "#FFFFFF",
  strokeMiterlimit: 10,
  width: 30,
  height: 30
}), /*#__PURE__*/React.createElement("rect", {
  x: -49.5,
  y: 22.5,
  fill: "#000000",
  stroke: "#FFFFFF",
  strokeMiterlimit: 10,
  width: 30,
  height: 30
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M90.078,21H85v-2h-9v2H66V10.999C66,9.814,64.91,9,63.725,9H35.819C34.634,9,34,9.814,34,10.999V21H23v-2h-8v2H9.463   C4.602,21,1,25.431,1,30.293v54.073C1,89.227,4.602,93,9.463,93h80.615C94.941,93,99,89.227,99,84.366V30.293   C99,25.431,94.941,21,90.078,21z M17,91V22h4v69H17z M61,21H38v-8h23V21z M78,91V22h5v69H78z"
}));

var SvgNounSuitcase10620 = function SvgNounSuitcase10620(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNounSuitcase10620, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/noun_Suitcase_10620.46cbc93e.svg";
export { ForwardRef as ReactComponent };